import React, { useEffect, useState } from 'react';
//import BreadCrumbTemplate from 'app/modules/breadCrumbTemplate';
import { Route, useParams, useLocation } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../../../../app/config/store';
import { CasereviewListView } from './CasereviewListView';
interface Props {
  handleViews?: any;
  id?: any;
  parentPage?: any;
  cardCols?: any;
}

export const CaseReview = (props: Props) => {
  const [showViews, setShowViews] = useState('');
  const [id, setId] = useState(undefined);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const params = useParams<'id'>().id;
  const { state } = location;

  useEffect(() => {}, [params]);

  const handleViews = (type, id) => {
    setShowViews(type);
    setId(id);
  };

  return (
    <div>
      <div className="contentRow">
        <div className="my-component mt-4 mb-4">
          <Col className="col-md-12">
            <CasereviewListView handleViews={handleViews} id={id} />
          </Col>

          <span id="custom-components" />
        </div>
      </div>
    </div>
  );
};

export default CaseReview;
